import uploadsscholarshipssidebyside04imageattorneyGroupPhotoJpeg from "$lib/data/generated/uploads/scholarships/SideBySide 04/image/Attorney Group Photo.jpeg?as=run";

export const uploads = {
  "uploads/scholarships/SideBySide 04/image/Attorney Group Photo.jpeg": uploadsscholarshipssidebyside04imageattorneyGroupPhotoJpeg
};